module.exports = __webpack_public_path__ + "media/assets_v3/images/csgo-ranks/16-62df018ec5d401b0b2ccc7c0a1ca4932.png";